// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ptwmlakD2R8IgTgWTouP{justify-content:space-between;align-items:center;display:flex}.CohMKxs2nHgjBKnQkaVe .lQoU8M8Bh3MXUMp0LbAZ{border:1px solid var(--border-neutral-default);border-radius:6px;margin:24px 0 17px}.CohMKxs2nHgjBKnQkaVe .aTCnmCDagE4dqUyAOfTQ{background:0 0;padding:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phoneCheckrModalTitle": `ptwmlakD2R8IgTgWTouP`,
	"phoneCheckrModalContent": `CohMKxs2nHgjBKnQkaVe`,
	"phoneCheckrModalInputs": `lQoU8M8Bh3MXUMp0LbAZ`,
	"phoneCheckrModalInput": `aTCnmCDagE4dqUyAOfTQ`
};
export default ___CSS_LOADER_EXPORT___;
